import { z } from "zod";

// sync with the backend
const SPECIAL_CHARACTERS = " !\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~";

const passwordRules = [
  { label: "Min 8 characters", validate: (v: string) => v.length >= 8 },
  {
    label: "Includes upper case and lower case",
    validate: (v: string) => /[a-z]/.test(v) && /[A-Z]/.test(v),
  },
  {
    label: "Includes special character",
    validate: (v: string) =>
      [...v].some((character) => SPECIAL_CHARACTERS.includes(character)),
  },
  { label: "Includes number", validate: (v: string) => /\d/.test(v) },
];

const getPasswordRequirements = (value: string) =>
  passwordRules.map(({ label, validate }) => ({ label, met: validate(value) }));

const passwordRulesSchema = z
  .string()
  .min(1, "A password is required")
  .refine(
    (value) => passwordRules.every(({ validate }) => validate(value)),
    "Your password doesn't meet the requirements",
  );

export { getPasswordRequirements, passwordRulesSchema };
